import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';

import { InfiniteScroll } from '../../components/infinitescroll';
import {
  CompanyUsersListQuery as CompanyUsersListQueryResult,
  CompanyUsersListQueryVariables,
  getNodes,
  loadMoreFromConnection,
} from '../../lib/graphql';
import { Loader } from '../../lib/loader';
import { UserInCompanyActionBar } from '../components/user_in_company_action_bar';
import { UserInCompanyList, UserInCompanyListDataProps } from '../components/user_in_company_list';
import { companyUsersListQuery } from '../graphql';

class LoadingContainer extends Loader<
  CompanyUsersListQueryResult,
  UserInCompanyListDataProps,
  CompanyUsersListQueryVariables
> {}

export const UserInCompanyListContainer = () => {
  const { company_id } = useParams() as { company_id: string };
  const [userSearchInput, setUserSearchInput] = useState('');
  const [appliedUserSearch, setAppliedUserSearch] = useState('');

  useEffect(() => {
    const handler = setTimeout(() => {
      if (userSearchInput.trim().length === 0 || userSearchInput.trim().length >= 1) {
        setAppliedUserSearch(userSearchInput);
      }
    }, 200);
    return () => clearTimeout(handler);
  }, [userSearchInput]);

  const result = useQuery<CompanyUsersListQueryResult, CompanyUsersListQueryVariables>(companyUsersListQuery, {
    variables: { company_id, search: appliedUserSearch },
  });

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 250px)' }}>
      <UserInCompanyActionBar
        data={{
          totalRegularUsersCount: result.data?.company?.users.totalRegularUsersCount ?? 0,
          totalAdminUsersCount: result.data?.company?.users.totalAdminUsersCount ?? 0,
          usersInCompany: result.data?.company?.users.users.edges
            ? getNodes(result.data.company.users.users).map(
                ({ user, role, metadata, invitedByUser, createdAt, lastUiActivityAt }) => ({
                  createdAt,
                  lastUiActivityAt,
                  user,
                  role,
                  persona: metadata !== null ? metadata.persona : null,
                  invitedByUser,
                }),
              )
            : null,
        }}
        company={{ company_id }}
        userSearchInput={userSearchInput}
        setUserSearchInput={setUserSearchInput}
        onSearch={() => setAppliedUserSearch(userSearchInput)}
      />
      <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        <LoadingContainer
          result={result}
          mapData={({ data }) => ({
            data: {
              usersInCompany: getNodes(data?.company?.users.users).map(
                ({ user, role, metadata, invitedByUser, createdAt, lastUiActivityAt }) => ({
                  createdAt,
                  lastUiActivityAt,
                  user,
                  role,
                  persona: metadata !== null ? metadata.persona : null,
                  invitedByUser,
                }),
              ),
            },
          })}>
          {({ data }) => (
            <InfiniteScroll
              className="company-users-list"
              triggerOnWindow={false}
              loadMoreEntries={() =>
                loadMoreFromConnection(companyUsersListQuery, result, ['company', 'users', 'users'])
              }>
              <UserInCompanyList data={data} company={{ company_id }} />
            </InfiniteScroll>
          )}
        </LoadingContainer>
      </div>
    </div>
  );
};
